import useEnabledFeatures from './useEnabledFeatures';

export default function useIsFeatureEnabled(name: string): boolean | undefined {
  const enabledFeatures = useEnabledFeatures();
  return enabledFeatures?.includes(name);
}
